import { getViewFromPathname, getWindowPathname } from 'email-management-lib/EarlyRequest/utils';
import { DEFAULT_VIEW_PATH } from 'email-management-lib/Shared/constants/frameworkTable';
export function getIsDeletedView() {
  const pathname = getWindowPathname();
  return getViewFromPathname(pathname) === DEFAULT_VIEW_PATH.DELETED;
}
export function getIsIssuesView() {
  const pathname = getWindowPathname();
  return getViewFromPathname(pathname) === DEFAULT_VIEW_PATH.ISSUES;
}